import { Card, Divider, Title } from '@mantine/core'

import { useTranslation } from '@flecto/translations'

import { ListNavigationCategories } from './ListNavigationCategories'

export function CardNavigationCategories() {
  const { t } = useTranslation('store', {
    keyPrefix: 'store-page-product-list',
  })

  return (
    <Card mt='xl'>
      <Title order={5}>{t('label_explore_categories')}</Title>
      <Divider my='md' color='gray.3' />
      <ListNavigationCategories mt='mb' />
    </Card>
  )
}
